export const extractTagValueFromTagsString = (tagsString, targetTag) => {
  if (!tagsString || !targetTag) return null;

  const escapedTargetTag = targetTag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  return (
    tagsString
      .match(new RegExp(`${escapedTargetTag}([^,]+)(?:,|$)`))?.[1]
      .trim() || null
  );
};
